export const PaperSigningStatusVals = {
    None: 0,
    Pending: 1,
    InProgress: 2,
    Completed: 3,
    Failed: 4
};
